module.exports = __webpack_public_path__ + "img/framme-store-demo.871c6b50.jpg";